export const calculateROI = (spend: number | undefined, revenue: number | undefined) => {
  if (spend == undefined || revenue == undefined) return null;
  if (spend == 0) return null;
  return (100 * (revenue - spend)) / spend;
};

export const safeCalculateROI = (spend: number | undefined, revenue: number | undefined) => {
  if (spend == undefined || revenue == undefined) return 0;
  if (spend == 0) return 0;
  return (100 * (revenue - spend)) / spend;
};
